import ExhibitorCarContainer from "../../../Component/Application/StaffCars/ExhibitorCarContainer"; 

const ExhibitorstaffCarsPage = () => {

    return(
        <div className="page-body">
            <ExhibitorCarContainer />
        </div>
    );
};

export default ExhibitorstaffCarsPage;